<script setup lang="ts">
import { EyeIcon, EyeOffIcon } from '@heroicons/vue/solid';

withDefaults(
  defineProps<{
    id: string;
    modelValue?: string;
    label: string;
    showForgotPasswordLink?: boolean;
    errors?: any;
    disabled?: boolean;
  }>(),
  {
    showForgotPasswordLink: false,
    disabled: false
  }
);

defineEmits<{
  'update:modelValue': [value: string];
}>();
const showPassword = ref(false);

const toggleShowPassword = (e: Event) => {
  e.preventDefault();
  showPassword.value = !showPassword.value;
};
</script>
<template>
  <div class="space-y-2">
    <Label :for="id" class="text-base">{{ label }}</Label>
    <div class="relative">
      <Input
        :id="id"
        :value="modelValue"
        @update:model-value="$emit('update:modelValue', $event)"
        :model-value="modelValue"
        :type="showPassword ? 'text' : 'password'"
        class="rounded-none border-gainsboro"
        :class="{ 'border-b-1 border-cinnabar border-x-transparent border-t-transparent bg-cinnabar-50': errors }"
        :disabled="disabled"
      />
      <Button
        @click="toggleShowPassword"
        variant="plain"
        type="button"
        class="absolute right-0 top-0 px-4 hover:brightness-75"
        aria-label="Show password"
      >
        <EyeOffIcon v-if="showPassword" class="size-5 stroke-2" />
        <EyeIcon v-else class="size-5 stroke-2" />
      </Button>
      <nuxt-link
        v-if="showForgotPasswordLink"
        to="/forgot-password"
        tabindex="0"
        aria-label="Forgot password"
        class="absolute -top-8 right-0 hidden underline md:block"
        >Forgot password?</nuxt-link
      >
    </div>
    <InputError :error="errors" />
  </div>
</template>
